exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".component---1m-jB {\n  height: 100%;\n  min-width: 1100px; }\n  .component---1m-jB > div {\n    height: 100%; }\n  .component---1m-jB .report-container---1H7tf {\n    border-top: 1px solid #e1e1e1;\n    padding-top: 16px; }\n", ""]);

// exports
exports.locals = {
	"component": "component---1m-jB",
	"report-container": "report-container---1H7tf"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./containers/live-maths/live-maths.scss
// module id = Cz3N
// module chunks = 1